import { post } from "../../service/api";

const ResetPasswordRequest = async (payload) => {
  try {
    const response = await post(`/merchant/resetPasswordRequest`, payload);
    return response;
  } catch (error) {
    console.error("Error resetPasswordRequest:", error);
    throw error;
  }
};

export default ResetPasswordRequest;
